/*
 * Digital Fortrydelsesret (EU) — storefront form handler.
 * POSTer {order_number, email|phone} til backend og viser straks resultatet.
 * Mønster: assets/car-filter-bar.js (inflight-guard, statusbeskeder).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fortryd]');
  if (!root) return;

  var endpoint = root.getAttribute('data-endpoint') || '';
  var supportEmail = root.getAttribute('data-support-email') || 'kundeservice@jmdimensions.com';
  var form = root.querySelector('[data-fortryd-form]');
  var btn = root.querySelector('[data-fortryd-submit]');
  var msg = root.querySelector('[data-fortryd-msg]');
  if (!form || !btn || !msg || !endpoint) return;

  var btnLabel = btn.textContent;
  var inflight = false;

  function setMsg(text, type) {
    msg.textContent = text;
    msg.className = 'fortryd-msg is-visible is-' + type;
  }
  function clearMsg() {
    msg.className = 'fortryd-msg';
    msg.textContent = '';
  }
  function setLoading(loading) {
    inflight = loading;
    btn.disabled = loading;
    btn.textContent = loading ? 'Behandler…' : btnLabel;
  }

  function looksLikeEmail(v) {
    return v.indexOf('@') > -1 && /\S+@\S+\.\S+/.test(v);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (inflight) return;

    var orderNumber = (form.querySelector('[name="order_number"]').value || '').trim();
    var contact = (form.querySelector('[name="contact"]').value || '').trim();

    if (!orderNumber || !contact) {
      setMsg('Udfyld venligst både ordrenummer og email/telefon.', 'error');
      return;
    }

    var payload = { order_number: orderNumber };
    if (looksLikeEmail(contact)) {
      payload.email = contact;
    } else {
      payload.phone = contact;
    }

    setLoading(true);
    setMsg('Tjekker din ordre…', 'info');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { status: res.status, data: data }; })
          .catch(function () { return { status: res.status, data: {} }; });
      })
      .then(function (out) {
        setLoading(false);
        var data = out.data || {};

        if (out.status === 429) {
          setMsg('For mange forsøg lige nu. Vent et øjeblik og prøv igen.', 'error');
          return;
        }

        if (data.success && data.cancelled) {
          setMsg(data.message || 'Din ordre er nu annulleret. Du modtager en bekræftelse på email.', 'success');
          form.reset();
          return;
        }

        // Blokeret / ikke fundet / fejl — vis backendens danske besked.
        setMsg(
          data.error || ('Ordren kunne ikke annulleres. Kontakt os på ' + supportEmail + '.'),
          'error'
        );
      })
      .catch(function () {
        setLoading(false);
        setMsg('Der opstod en netværksfejl. Tjek din forbindelse og prøv igen — eller kontakt os på ' + supportEmail + '.', 'error');
      });
  });
})();
